export default __webpack_public_path__ + "static/media/file_document.91887f17.svg";